import { Component } from '@angular/core';
import { NotificationCategory } from '../misc/enums/notification-category.enum';
import { NotificationType } from '../misc/enums/notification-type.enum';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';
import { NotificationHandlerService } from '../services/notification-handler.service';
import { GlobalConstants } from '../services/global-constants';
import { DatePipe } from '@angular/common';
import { DateService } from '../services/date.service';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { TranslatorPipe } from '../services/translator.pipe';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {


  //Data Attributes
  notifications: any[] = [];
  filteredNotifications: any[] = [];

  //Filter attributes
  currentCategory: NotificationCategory = NotificationCategory.ALL;
  categoryFilters = Object.values(NotificationCategory);

  //Comparison attributes
  userId: any = localStorage.getItem('uid');

  //Network attributes
  staticFileUrl: string = GlobalConstants.staticFilesURL;
  skelition: boolean = true;


  constructor(
    private dataService: DataService,
    private router: Router,
    private notificationHandler: NotificationHandlerService,
    private dateService: DateService,
    private permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    this.filterCategories();
    this.getNotificaitons();
    this.notificationHandler.getNotifications().subscribe(notificaiton => {
      this.notifications.unshift(notificaiton);
    });
  }

  filterCategories() {
    this.categoryFilters = this.categoryFilters.filter(e => {
      if (e == NotificationCategory.DATA_EVENTS) {
        return this.permissionService.hasPermission('DATA', 'r') ||
          this.permissionService.hasPermission('CONTENT', 'r') ||
          this.permissionService.hasPermission('CONTENT_APPROVE', 'a') ||
          this.permissionService.hasPermission('COMMENTS', 'r');
      } else if (e == NotificationCategory.USER_EVENTS) {
        return this.permissionService.hasPermission('USER_MANAGEMENT', 'r');
      } else if (e == NotificationCategory.KLIBRARY) {
        return this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'r');
      } else if (e == NotificationCategory.MY) {
        return true;
      } else if (e == NotificationCategory.ALL) {
        return (this.permissionService.hasPermission('DATA', 'r') ||
          this.permissionService.hasPermission('CONTENT', 'r') ||
          this.permissionService.hasPermission('CONTENT_APPROVE', 'a') ||
          this.permissionService.hasPermission('COMMENTS', 'r')) &&
          this.permissionService.hasPermission('USER_MANAGEMENT', 'r') &&
          this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'r');
      }
      return false;
    })
  }

  changeCurrentFilter(filter: NotificationCategory) {
    this.currentCategory = filter;
    if (filter == NotificationCategory.ALL) {
      this.filteredNotifications = this.notifications;
    } else if (filter == NotificationCategory.MY) {
      console.log(this.userId, this.notifications);

      this.filteredNotifications = this.notifications.filter((n: any) => n.sender._id == this.userId);
    } else {
      this.filteredNotifications = this.notifications.filter((n: any) => n.category == filter);
    }
  }

  async getNotificaitons() {
    if (this.notifications.length == 0) {
      try {
        this.skelition = true;
        let res = await this.dataService.getData('notification/own');
        this.skelition = false;
        if (!res.error) {
          this.notifications = res.data.filter((e: any) => {
            return (this.notificationHandler.applyPermissions(e) && this.notificationHandler.applyDatePermission(e));
          }).map((n: any) => {
            return this.notificationHandler.setNotificationTypeMessage(n);
          }).sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          this.filteredNotifications = this.notifications;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  isSeen(notification: any): boolean {
    if (!this.userId) {
      return false;
    }
    return notification.seenBy.includes(this.userId);
  }

  async markSeen(notification: any) {
    try {
      if (this.isSeen(notification) == false) {
        let res = await this.dataService.postData('notification/' + notification._id, {}, 'PUT', false);
        if (!res.error) {
          let userId = localStorage.getItem('uid');
          notification.seenBy.push(userId);
        }
      }
      this.notificationHandler.navigateToRoute(notification);
    } catch (e) {
      console.log(e);
    }
  }


  getDateDifference(date: any) {
    return this.dateService.getDataDiff(date, new Date())
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getCategoryArabics(category: string) {
    if (category == NotificationCategory.KLIBRARY) {
      return this.translate(`${category} Events`)
    }
    return this.translate(category);
  }

  checkIsImage(img: string) {
    return this.notificationHandler.checkisImg(img);
  }


}
